export interface InvitationValidationResponse {
  valid: boolean;
  reason?: 'not_found' | 'status_invalid' | 'expired' | 'email_mismatch';
  hasExistingAccount?: boolean;
  invitation?: {
    email: string;
    expiresAt: string;
  };
}

export async function validateInvitationForRegistration(
  invitationToken: string,
  email?: string
): Promise<InvitationValidationResponse> {
  const isLocalhost =
    typeof window !== 'undefined' &&
    (window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1');
  const apiUrl = isLocalhost
    ? 'http://localhost:3001/api/teams/validate-invitation'
    : '/api/teams/validate-invitation';

  const body: { invitationToken: string; email?: string } = { invitationToken };
  if (email !== undefined) {
    body.email = email;
  }

  const response = await fetch(apiUrl, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    const errorBody = await response.json().catch(() => ({}));
    const message = errorBody?.error || 'Failed to validate invitation';
    throw new Error(message);
  }

  return response.json() as Promise<InvitationValidationResponse>;
}

/** Resolve invited rower email from a pending team invitation token (pre-auth). */
export async function lookupInvitationForRegistration(
  invitationToken: string
): Promise<InvitationValidationResponse> {
  return validateInvitationForRegistration(invitationToken);
}
